import React, { useEffect, useState } from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api, endpoints } from "@/lib/api";

export const FAQSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.faqs).then(setItems).catch(() => {}); }, []);
  return (
    <section id="faq" className="surface-tint">
      <div className="container-wide py-16 lg:py-24 max-w-4xl">
        <SectionHeader eyebrow="FAQ" title="Answers to the questions we get most." lead="If you can’t find your answer here, use the contact form below." />
        <Reveal>
          <Accordion type="single" collapsible className="bg-card rounded-xl border border-[hsl(var(--border))]" data-testid="faq-accordion">
            {items.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="px-4">
                <AccordionTrigger data-testid={`faq-question-${f.id}`} className="text-left text-[hsl(var(--navy))]">{f.q}</AccordionTrigger>
                <AccordionContent className="text-[hsl(var(--muted-ink))]">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
